import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-option-result-dto';

export class BankAccountSelectorResultDto {
    bankAccountId: number;
    bankName: string;
    accountName: string;
    accountNumber: string;
    glAccountNumber: string;
    isDefault: boolean;
    isDefaultAPAccount: boolean;
    isDefaultARAccount: boolean;

    @Type(() => DimensionOptionResultDto)
    glDimensions: DimensionOptionResultDto[] = [];

    get displayBankName(): string {
        return `${this.bankName};${this.accountName};${this.accountNumber}; ${this.dimensionDisplayText}`;
    }

    // Transient
    dimensionDisplayText = '';
}
